
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import CSSLoader from './components/CSSLoader';
import './App.css';
import './css/skeleton.css';
import Home from './pages/Home';
import DogList from './pages/DogList';
import AdoptionsPages from './pages/AdoptionsPages'
import ContactPage from './pages/ContactPage'
import BlogPage from './pages/BlogPage'
import BlogDetailsPage from './pages/BlogDetailsPage'
import ShopPages from './pages/ShopPages'
import NewShopDetailsPage from './pages/NewShopDetailsPage'
import BreederPage from './pages/BreederPage'
import BreederDetailsPage from './pages/BreederDetailsPage'
import HometwoPage from './pages/HometwoPage'
import CartPage from './pages/CartPage'
import CheckoutPage from './pages/CheckoutPage'
import ComingSoonPage from './pages/ComingSoonPage';
import InfoPage from './pages/InfoPage'
import PolitiqueRetourPage from './pages/PolitiqueRetourPage';
import TermesConditionsPage from './pages/TermesConditionsPage';
import PolitiqueConfidentialitePage from './pages/PolitiqueConfidentialitePage';
import NotFoundPage from './pages/NotFoundPage';
import ScrollToTopRoute from './ScrollToTopRoute'
import { ShopProvider } from './context/ShopContext';

function App() {

  return (
    <div className='app'>
      <CSSLoader />
      <Router>
        <Header />
        <ShopProvider>
          <Switch>
            <ScrollToTopRoute exact={true} path='/'>
              <Home />
            </ScrollToTopRoute>


            <ScrollToTopRoute exact={true} path='/contacts'>
              <ContactPage />
            </ScrollToTopRoute>

            <ScrollToTopRoute exact={true} path='/shop'>
              <ShopPages />
            </ScrollToTopRoute>
            <ScrollToTopRoute path='/shop/:productSlug'>
              <NewShopDetailsPage />
            </ScrollToTopRoute>


            <ScrollToTopRoute exact={true} path='/cart'>
              <CartPage />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path='/checkout'>
              <CheckoutPage />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path='/info'>
              <InfoPage />
            </ScrollToTopRoute>

            <ScrollToTopRoute exact={true} path='/politique-retour'>
              <PolitiqueRetourPage />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path='/termes-conditions'>
              <TermesConditionsPage />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path='/politique-confidentialite'>
              <PolitiqueConfidentialitePage />
            </ScrollToTopRoute>

            <ScrollToTopRoute exact={true} path='/coming-soon'>
              <ComingSoonPage />
            </ScrollToTopRoute>


            <ScrollToTopRoute>
              <NotFoundPage />
            </ScrollToTopRoute>

          </Switch>
        </ShopProvider>
        <Footer />
      </Router>

    </div>
  );
}

export default App;
